import { Injectable } from '@angular/core';
import { DescriptionReduite } from '../../models/DescriptionReduite';

@Injectable({
  providedIn: 'root'
})
export class DescriptionReduiteService {

  constructor() {
  }

  public getDescriptionReduite(controls): DescriptionReduite {
    const descriptionReduite = new DescriptionReduite();
    descriptionReduite.objet = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepAtt_objet');
    return descriptionReduite;
  }
}
